import * as Dialog from '@radix-ui/react-dialog'
import classNames from 'classnames'
import { ComponentPropsWithoutRef, ReactNode } from 'react'

import styles from './modal.module.css'

export interface LegacyModalProps extends ComponentPropsWithoutRef<typeof Dialog.Root> {
    children: ReactNode
    contentClassName?: string
    contentProps?: Omit<ComponentPropsWithoutRef<typeof Dialog.Content>, 'children' | 'className'>
    overlayClassName?: string
    trigger?: ReactNode
}

export const Modal = ({
    children,
    contentClassName,
    contentProps,
    overlayClassName,
    trigger,
    ...rootProps
}: LegacyModalProps) => (
    <Dialog.Root { ...rootProps }>
        { trigger ? (
            <Dialog.Trigger asChild>
                { trigger }
            </Dialog.Trigger>
        ) : null }
        <Dialog.Portal>
            <Dialog.Overlay className={ classNames(styles.overlay, overlayClassName) } />
            <Dialog.Content
                { ...contentProps }
                className={ classNames(styles.content, contentClassName) }
            >
                { children }
            </Dialog.Content>
        </Dialog.Portal>
    </Dialog.Root>
)

export const ModalTitle = Dialog.Title
export const ModalDescription = Dialog.Description
export const ModalClose = Dialog.Close
